import React  from 'react'
import Input from 'components/Input'
import { withTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import Btn, { FormBtn } from './Btn'
import { Grid } from '@mui/material'
import DatePickers from './DatePickers'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

export default withTranslation()(function Filter({ t, getParams, page = '' }) {
  const { getValues, formState: { isValid, isDirty }, reset } = useFormContext()
  // const { queryParams, setQueryParams } = useContext(RedemptionVaultContext)
  const navigate = useNavigate()


  const filt = () => {
    const removeUndefined = () => Object.entries(getValues()).map(x => x[1] && x).filter(x => x && x)
    let params = new URLSearchParams(Object.fromEntries(removeUndefined())).toString()
    if (params.start_date) { params = (new URLSearchParams(Object.assign(params, { start_date: dayjs(params.start_date).format('YYYY-MM-DD') }))) }
    if (window.location.pathname === '/redemption-vault') {
      navigate(`/redemption-vault?${params}`)
    } else {
      navigate(`${window.location.pathname}?${params}`)
    }
  }
  return (
    <>
      <Grid item xs={12}>
        <Input
          isMulti
          options={[
            {
              label: t('transaction.table.status.paid'),
              value: 'completed'
            },
            {
              label: t('transaction.table.status.pending'),
              value: 'pending'
            },
            {
              label: t('transaction.table.status.rejected'),
              value: 'rejected'
            }
          ]}
          label={t('misc.status')}
          name="statuses"
          variant="filled"
        />

      </Grid>
      <Grid item xs={12}>
        <Input
          isMulti
          options={[
            {
              label: 'Cash/Money',
              value: 'completed'
            },
            {
              label: 'Coins/Rewards',
              value: 'coin'
            },
            {
              label: 'External POS',
              value: 'ext'
            },
            {
              label: 'ReachAfrika Wallet',
              value: 'wallet'
            }
          ]}
          label={t('transaction.table.payment_method_header')}
          name="payment_method"
          variant="filled"
        />

      </Grid>
      <Grid item xs={12} lg={5.5}>
        <Input
          name="amount_start"
          label={'Amount start'}
          type="number"
          variant="filled"
        />
      </Grid>

      <Grid item xs={12} lg={5.5}>
        <Input
          name="amount_end"
          label={'Amount end'}
          type="number"
          variant="filled"
        />
      </Grid>
      <Grid item xs={12} lg={5.5} >
        <Input
          name="phone"
          label={'Phone'}
          variant="filled"
        />
      </Grid>
      <Grid item xs={12} lg={5.5} >
        <Input
          name="email"
          label={'Email'}
          variant="filled"
        />
      </Grid>
      <Grid item xs={12} lg={5.5} className='mt-3' >
        {/* <DatePickers /> */}
        <DatePickers
          name="start_date"
          label={t('misc.logout.start')}
          variant="filled"
        />
      </Grid>

      <Grid item xs={12} lg={5.5} className='mt-3' >
        <DatePickers
          name="end_date"
          label={t('misc.logout.end')}
          variant="filled"
        />
      </Grid>

      <Grid item xs={5.5} lg={5.5} className={' flex items-center justify-center'}>
        <Btn
          content={'Reset'}
          className="h-12 text-white w-[100%] mx-auto mt-5 bg-secondary rounded-xl ml-1/5"
          click={() => {
            reset({
              status: '',
              amount_start: '',
              amount_end: '',
              start_date: '',
              end_date: '',
            })
          }}
        />
      </Grid>
      <Grid item xs={5.5} lg={5.5} className={' flex items-center gap-[5px] justify-center'}>
        <FormBtn
          content={t('settlements.table.filter')}
          className="h-12 text-white w-[100%] mx-auto mt-5 bg-primary rounded-xl ml-1/5"
          disabled={!isValid || !isDirty}
          click={() => filt()}
          type='button'
        />
      </Grid>
    </>
  )
})